const angular = require('angular')
const contactListService = require('./contactListService')
const contactListMixin = require('./contactListMixin')
const contactListCtrl = require('./contactListCtrl')
const selectContactListCtrl = require('./selectContactListCtrl')
const personalContactCtrl = require('./personalContactCtrl')
const createContactGroupCtrl = require('./createContactGroupCtrl')
const watermark = require('../../../directives/watermark')

module.exports = angular.module('hxphone.contactList', ['hxphone.services'])
  .factory('contactListService', contactListService)
  .factory('contactListMixin', contactListMixin)
  .controller('contactListCtrl', contactListCtrl)
  .controller('selectContactListCtrl', selectContactListCtrl)
  .controller('personalContactCtrl', personalContactCtrl)
  .controller('createContactGroupCtrl', createContactGroupCtrl)
  .directive('watermark', watermark)



// WEBPACK FOOTER //
// ./src/js/addressbook/organizational/contact/module.js